import { Pipe, PipeTransform } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { SaleItem } from './sale-item'
import { productSelectors } from '../../product/product.selectors'
import { AppState } from '../../../core/core.state'
import { SaleItemPriceDetails, SaleItemService } from './sale-item.service'

@Pipe({
  name: 'getSaleItemProductPrice'
})
export class GetSaleItemProductPricePipe implements PipeTransform {
  productEntities$ = this.store.select(productSelectors.selectEntities)

  constructor(
    private store: Store<AppState>,
    private saleItemService: SaleItemService
  ) {}

  transform(saleItem: SaleItem): Observable<SaleItemPriceDetails> {
    return this.saleItemService.getSaleItemPriceDetails$(saleItem)
  }
}
